<template>
  <div class="iq-card ae-card">
    <div class="iq-card-body ae-card-body">
      <div class="ae-header">
        <div class="ae-title-wrap">
          <h5 class="card-title ae-title">{{ title }}</h5>
          <span class="badge badge-success" v-if="isOn">ON</span>
          <span class="badge badge-danger" v-else>OFF</span>
        </div>
        <p class="ae-hour">
          {{ runningSeconds }}
          <span class="text-muted ae-unit">hour</span>
        </p>
      </div>
      <span class="ae-cons">
        AE Cons:
        {{
          typeof fuelConsumption === 'number'
            ? fuelConsumption.toFixed(2)
            : '-'
        }}
        L
      </span>
      <template v-if="isHavePowerMeter">
        <hr class="ae-divider" />
        <p class="ae-metrics-title">Power Meter</p>
        <div class="ae-metrics">
          <div class="ae-metric">
            <span class="ae-metric-label">Active Power</span>
            <span class="ae-metric-value">
              {{ typeof totalPower === 'number' ? totalPower.toFixed(2) : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Apparent Power</span>
            <span class="ae-metric-value">
              {{ typeof apparentPower === 'number' ? apparentPower.toFixed(2) : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Total Energy</span>
            <span class="ae-metric-value">
              {{ typeof totalEnergy === 'number' ? totalEnergy : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Freq.</span>
            <span class="ae-metric-value">
              {{ typeof frequency === 'number' ? frequency : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Volt. L-to-L</span>
            <span class="ae-metric-value">
              {{ typeof voltageLtoL === 'number' ? voltageLtoL : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Volt. L-to-N</span>
            <span class="ae-metric-value">
              {{ typeof voltageLtoN === 'number' ? voltageLtoN : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Current</span>
            <span class="ae-metric-value">
              {{ typeof current === 'number' ? current : '-' }}
            </span>
          </div>

          <div class="ae-metric">
            <span class="ae-metric-label">Power Factor</span>
            <span class="ae-metric-value">
              {{ typeof powerFactor === 'number' ? powerFactor : '-' }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuxiliaryEngineCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    isOn: {
      type: Boolean,
      default: false,
    },
    runningSeconds: {
      type: String,
      default: '-',
    },
    fuelConsumption: {
      type: [Number, String],
      default: '-',
    },
    totalPower: {
      type: [Number, String],
      default: null,
    },
    apparentPower: {
      type: [Number, String],
      default: null,
    },
    totalEnergy: {
      type: [Number, String],
      default: null,
    },
    frequency: {
      type: [Number, String],
      default: null,
    },
    voltageLtoL: {
      type: [Number, String],
      default: null,
    },
    voltageLtoN: {
      type: [Number, String],
      default: null,
    },
    current: {
      type: [Number, String],
      default: null,
    },
    powerFactor: {
      type: [Number, String],
      default: null,
    },
    isHavePowerMeter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ae-card {
  height: 100%;
  overflow: hidden;
}

.ae-card-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ae-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.ae-title-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ae-title {
  margin: 0;
}

.ae-hour {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  line-height: 22px;
  text-align: right;
}

.ae-unit {
  font-size: 0.6875rem;
}

.ae-cons {
  font-size: 0.875rem;
  color: #6b7280;
}

.ae-divider {
  margin: 6px 0 2px;
  border: 0;
  border-top: 1px solid #e5e7eb;
}

.ae-metrics-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 2px;
}

.ae-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px 12px;
  min-width: 0;
}

.ae-metric {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  padding-right: 10px;
  border-right: 1px solid #e5e7eb;
  min-width: 0;
}

.ae-metric:nth-child(4n) {
  border-right: 0;
  padding-right: 0;
}

.ae-metric-label {
  font-size: 0.875rem;
  color: #6b7280;
  min-width: 0;
}

.ae-metric-value {
  font-size: 0.875rem;
  color: #111827;
  font-weight: 600;
  min-width: 0;
  text-align: right;
  white-space: nowrap;
}

@media screen and (max-width: 1400px) {
  .ae-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ae-metric {
    border-right: 0;
    padding-right: 0;
  }

  .ae-metric:nth-child(odd) {
    border-right: 1px solid #e5e7eb;
    padding-right: 10px;
  }
}

@media screen and (max-width: 991px) {
  .ae-metrics {
    grid-template-columns: minmax(0, 1fr);
  }

  .ae-metric {
    border-right: 0;
    padding-right: 0;
  }
}
</style>
